import { URL_ORIGINS } from '../constant/appConst'

export const getMatchingPlayerUrlOrigin = () => {
  const { origin } = new URL(window.location.href)
  const { OPEN_PRODUCTION, DWP_PRODUCTION, DWP_REC } = URL_ORIGINS
  return origin === OPEN_PRODUCTION
    ? DWP_PRODUCTION
    : DWP_REC
}



// WEBPACK FOOTER //
// ./src/utils/utils.js